<template>
  <!--
    @name: ArticleDetail.vue
    @description:
    @author:  GaoYu
    @time: 2020/7/22 10:48
  -->
  <div class="article-detail">
    <div class="article-detail-single" v-if="detailContent.type !== 2">
      <div class="line-box" v-if="detailContent.article_type == 1"></div>
      <div class="text" v-html="detailList[0].content" v-if="detailList.length > 0"></div>

      <!--链接卡片-->
      <!-- <div class="text">
        <a class="link-card-container">
          <div class="info-box">
            <div class="title">标题标题标题标题标题标题标题标题标题标题标题标标题标题标题标题标题标题标题标题标题标题标题标</div>
            <div class="author">作者：昵称昵称</div>
          </div>
          <div class="article-img">
            <img src="https://dianyuan-public.oss-cn-shenzhen.aliyuncs.com/static/eestar/App/xingqiuhao/suijitu.png" alt="">
          </div>
        </a>
      </div> -->
      <!--链接卡片 end-->

    </div>
    <div class="article-detail-multi"  v-if="detailContent.type === 2">
      <div class="article-item" v-for="(item, index) in detailList" :key="index"  v-if="detailList.length > 0">
        <div class="time">第{{index+1}}篇 {{item.publish_time}} 发布</div>
        <div class="text" v-html="item.content"></div>
      </div>
      <div class="article-item" v-if="detailContent.serialize_status !== 2">
        <div class="time">第{{detailList.length+1}}篇 未完待续...</div>
        <div class="finish-content"></div>
      </div>
    </div>
    <div v-show="detailList.length!=0" class="statement">声明：本内容为作者独立观点，不代表电子星球立场。未经允许不得转载。授权事宜与稿件投诉，请联系：editor@netbroad.com</div>
    <!-- <div class="bg-block"></div> -->
  </div>

</template>

<script>

export default {
  name: 'ArticleDetailComponents',
  props: {
    detailList: {
      type: Array
    },
    detailContent: {
      type: Object
    }
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  },
  watch: {
    detailContent () {
      this.$nextTick(() => {
        Prism.highlightAll()
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../assets/css/mixin.less';
  .text {
    font-size: 17px;
    font-weight: 400;
    color: #333333;
    line-height: 30px;
    text-align: justify;
    word-break: break-all;

    padding: 12px 16px 20px;

    /deep/ h1,/deep/ h2,/deep/ h3 {
      padding: 0;
      font-weight: 700;
      font-size: 19px;
    }
    /deep/ img {
      display: block;
      margin: 0 auto;
      max-width: 100%;
      &.math-formula {
        display: inline-block;
        margin: 0 5px;
        vertical-align: middle;
        cursor: pointer;
      }
    }
    /deep/ p, /deep/ ul, /deep/ ol, /deep/ div, /deep/ blockquote, /deep/ h1,/deep/ h2,/deep/ h3 {
      margin: 0 0 20px 0;
      padding: 0;
    }
    /deep/ ul li {
      list-style-type: disc;
      margin: 0 0 0 35px;
    }
    /deep/ ol li {
      list-style-type: decimal;
      margin: 0 0 0 35px;
    }
    /deep/ a {
      color:rgba(0,119,249,1);
    }
    /deep/ blockquote {
      display: block;
      padding: 15px 15px 15px 11px;
      border-left: 4px solid #DDDDDD;
      background: #F5F5F5;
      overflow: auto;
      overflow-scrolling: touch;
      word-wrap: normal;
      word-break: normal;
      font-size: 13px;
      line-height: 22px;
      color: #666666;
      p {
        padding: 0;
        margin: 0;
      }
    }
    /deep/ video {
      width: 100%;
    }
    /deep/ .video-cover {
      display: none;
    }

    /*链接卡片*/
    .link-card-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 10px 10px 15px;
      width: 318px;
      background: #F8F8F8;
      border-radius: 5px;
      .article-img {
        position: relative;
        margin: 0;
        width: 96px;
        height: 72px;
        img {
          width: 100%;
          height: 100%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center center;
          box-sizing: border-box;
          border-radius: 3px;
        }
      }
      .info-box {
        margin: 0;
        .title {
          .textEllipsis(198px, 2, 22px);
          margin-bottom: 8px;
          font-size: 16px;
          color: #333333;
        }
        .author {
          margin-bottom: 0;
          .height(17px);
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }

  .article-detail {
    .article-detail-single {
      .line-box {
        margin: 0 16px;
        border-bottom: 1px dashed #DDDDDD;
      }
    }
    .article-detail-multi {
      .article-item {
        .time {
          height: 30px;
          background: #EEEEEE;
          line-height: 30px;
          font-size:13px;
          font-weight:400;
          color: #999999;
          text-align: center;
        }
        .finish-content {
          height: 110px;
        }
      }
    }
    .statement {
      margin: 0 16px;
      height: 60px;
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
    .bg-block {
      width: 100%;
      height: 10px;
      background: #F5F5F5;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Article/ArticleDetail.vue